// extracted by mini-css-extract-plugin
module.exports = {"main-background":"BlogSingle_main-background___gQEA","blog-container":"BlogSingle_blog-container__1zuCU","loading":"BlogSingle_loading__1G_ih","min-h":"BlogSingle_min-h__CF98A"};